import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";

/* ================= ICONS ================= */
import AutoIcon from "../../assets/icons/menu-icons/AutoPersonal Injury Imagin-01.png";
import BodyIcon from "../../assets/icons/menu-icons/Body Imaging-01.png";
import CardiacIcon from "../../assets/icons/menu-icons/Cardiac Imaging-01.png";
import MskIcon from "../../assets/icons/menu-icons/Musculoskeletal Imaging-01.png";
import NeuroIcon from "../../assets/icons/menu-icons/Neurological Imaging-01.png";
import OncologyIcon from "../../assets/icons/menu-icons/Oncology Imaging-01.png";
import VascularIcon from "../../assets/icons/menu-icons/Vascular Imaging-01.png";
import WomenIcon from "../../assets/icons/menu-icons/Women's Imaging-01.png";
import MammographyIcon from "../../assets/icons/menu-icons/2D-3D Mammography-01.png";
import NuclearIcon from "../../assets/icons/menu-icons/Cardiac - Body Nuclear Medicine-01.png";
import XrayIcon from "../../assets/icons/menu-icons/Digital X-Ray-01.png";
import EchoIcon from "../../assets/icons/menu-icons/Echocardiography-01.png";
import UltrasoundIcon from "../../assets/icons/menu-icons/General Vascular Ultrasound-01.png";
import MRIIcon from "../../assets/icons/menu-icons/High-Field - Open MRI-01.png";
import CtIcon from "../../assets/icons/menu-icons/Low Dose 160-Slice Open CT-01.png";
import DexaIcon from "../../assets/icons/menu-icons/Osteoporosis DEXA Scan-01.png";
import PetCtIcon from "../../assets/icons/menu-icons/PET - CT-01.png";
import ProstateIcon from "../../assets/icons/menu-icons/Prostate-Cancer-01.png";
import { HashLink } from "react-router-hash-link";

/* ================= SERVICES DATA ================= */
const servicesMegaMenu = {
  subspecialties: [
    {
      label: "Auto/Personal Injury Imaging",
      icon: AutoIcon,
      link: "/personal-injury",
    },
    {
      label: "Body Imaging",
      icon: BodyIcon,
      link: "/diagnostic-imaging-services",
    },
    {
      label: "Cardiothoracic Imaging",
      icon: CardiacIcon,
      link: "/cardiac-imaging",
    },
    {
      label: "Musculoskeletal Imaging",
      icon: MskIcon,
      link: "/diagnostic-imaging-services",
    },
    {
      label: "Neurological Imaging",
      icon: NeuroIcon,
      link: "/diagnostic-imaging-services",
    },
    {
      label: "Oncology Imaging",
      icon: OncologyIcon,
      link: "/diagnostic-imaging-services",
    },
    {
      label: "Prostate Imaging",
      icon: ProstateIcon,
      link: "/prostate-on-mri",
    },
    {
      label: "Vascular Imaging",
      icon: VascularIcon,
      link: "/diagnostic-imaging-services",
    },
    {
      label: "Women’s Imaging",
      icon: WomenIcon,
      link: "/womens-imaging-center",
    },
  ],
  Tests: [
    {
      label: "2D/3D Mammography",
      icon: MammographyIcon,
      link: "/diagnostic-imaging-services",
    },
    {
      label: "Cardiac/General Nuclear Medicine",
      icon: NuclearIcon,
      link: "/diagnostic-imaging-services",
    },
    {
      label: "Digital X-Ray",
      icon: XrayIcon,
      link: "/diagnostic-imaging-services",
    },
    {
      label: "Echocardiography",
      icon: EchoIcon,
      link: "/diagnostic-imaging-services",
    },
    {
      label: "General/Vascular Ultrasound",
      icon: UltrasoundIcon,
      link: "/diagnostic-imaging-services",
    },
    {
      label: "High-Field/Open MRI",
      icon: MRIIcon,
      link: "/open-mri-and-imaging",
    },
    {
      label: "Low Dose 160-Slice Open CT",
      icon: CtIcon,
      link: "/diagnostic-imaging-services",
    },
    {
      label: "Osteoporosis DEXA Scan",
      icon: DexaIcon,
      link: "/diagnostic-imaging-services",
    },
    {
      label: "PET/CT",
      icon: PetCtIcon,
      link: "/pet-scan-imaging",
    },
  ],
};

/* ================= RESOURCES DATA ================= */
const resourcesMenu = [
  { label: "Insurance & Billing", link: "/resources" },
  { label: "Medical Records", link: "/resources#medical-records" },
  { label: "Advanced Technology & AI", link: "/advanced-ai-medical-imaging" },
  { label: "FAQs", link: "/faqs" },
];
const aboutMenu = [
  { label: "About", link: "/about-us" },
  { label: "History", link: "/about-us#history" },
  { label: "Leadership", link: "/about-us#leadership" },
  { label: "Featured Services", link: "/about-us#featured-services" },
  { label: "Accreditations", link: "/about-us#accreditations" },
];

export default function MobileMenu({ onClose }) {
  const [stack, setStack] = useState([]);
  const loginButtons = [
    {
      label: "Patient Login",
      url: "https://citrusfl.abbadox.com/patientportal/login",
    },
    {
      label: "Provider Login",
      url: "https://urldefense.proofpoint.com/v2/url?u=http-3A__www.abbadoxcareflow.com_&d=DwMF-g&c=euGZstcaTDllvimEN8b7jXrwqOf-v5A_CdpgnVfiiMM&r=YVOHKV0ooKH3u_8PMI-eeHLiArirMnx9nsjd9-WiR9xM4lyq7ur3jyAB6W7z4Zmo&m=x2SSMh8aAnzMxWYil6Wj-KzAqV0oRiNO0ZkByv6rll29F05I8J0Zmxh-RXWAtgXa&s=ez52n8cfnvSQa08OC11YLUHg0MTxZfA41JBnV2RJPyk&e=2.718",
    },
    {
      label: "Legal Login",
      url: "https://prod.myclearpath.com/login",
    },
  ];
  /* ===== SCROLL LOCK ===== */
  useEffect(() => {
    const scrollY = window.scrollY;
    document.documentElement.style.overflow = "hidden";
    document.body.style.position = "fixed";
    document.body.style.top = `-${scrollY}px`;
    document.body.style.width = "100%";
    return () => {
      document.documentElement.style.overflow = "";
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.width = "";
      window.scrollTo(0, scrollY);
    };
  }, []);

  const openMenu = (menu) => setStack([...stack, menu]);
  const goBack = () => setStack(stack.slice(0, -1));
  const activeMenu = stack[stack.length - 1];

  return (
    <div className="fixed left-0 right-0 bottom-0 top-[80px] h-screen z-50 bg-[#F3F3F3]">
      {/* MAIN MENU */}
      <div className="px-8 py-8">
        <ul className="space-y-6 font-bold text-[15px] text-[#383838]">
          <li>
            <Link to="/" onClick={onClose}>
              Home
            </Link>
          </li>
          <li>
            <MenuItem label="About" onClick={() => openMenu("About")} />
          </li>
          <li>
            <MenuItem label="Services" onClick={() => openMenu("Services")} />
          </li>
          <li>
            <Link to="/patient-portal" onClick={onClose}>
              Patients
            </Link>
          </li>
          <li>
            <Link to="/healthcare-providers" onClick={onClose}>
              Providers
            </Link>
          </li>
          <li>
            <MenuItem label="Resources" onClick={() => openMenu("Resources")} />
          </li>
          {/* <li><Link to="/ai-at-citrus" onClick={onClose}>AI</Link></li> */}
        </ul>
        <div className="flex flex-wrap mt-10 gap-5 gap-y-4 justify-center">
          {loginButtons.map(({ label, url }) => (
            <li key={label} className="list-none">
              <Link
                to={url}
                target="_blank"
                rel="noopener noreferrer"
                className="
    relative group
    w-[160px] 3xl:w-[230px] min-w-[160px] 3xl:min-w-[200px] h-[50px]
    rounded-full px-6
    border-2 border-black
    text-black font-bold
    bg-transparent overflow-hidden
    flex items-center justify-center
  "
              >
                <span className="relative flex items-center justify-center overflow-hidden h-6 w-full text-[15px] 3xl:text-[18px]">
                  <span className="block transition-transform duration-300 group-hover:-translate-y-full">
                    {label}
                  </span>
                  <span className="block absolute top-full left-0 w-full text-center transition-all duration-300 group-hover:top-0">
                    {label}
                  </span>
                </span>
              </Link>
            </li>
          ))}
        </div>
      </div>
      {/* ================= BOTTOM BAR ================= */}
      <div className="flex border-t border-black bottom-0 fixed w-full font-robout">
        <Link
          to="/contact-us"
          onClick={onClose}
          className="w-1/2 py-4 text-black font-black text-[14px] lg:text-[16px] leading-[1.4em] text-center"
        >
          CONTACT
        </Link>
        <a
          href="tel:3527959200"
          className="w-1/2 py-4 text-center font-black text-[14px] lg:text-[16px] leading-[1.4em] bg-black text-white font-robout"
        >
          (352) 795-9200
        </a>
      </div>

      {/* SLIDE PANEL */}
      <div
        className={`absolute inset-0 bg-[#F3F3F3] transition-transform duration-300 ${
          stack.length ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <MenuContent
          menu={activeMenu}
          openMenu={openMenu}
          goBack={goBack}
          onClose={onClose}
        />
      </div>
    </div>
  );
}

/* ================= MENU CONTENT ================= */

function MenuContent({ menu, openMenu, goBack, onClose }) {
  if (!menu) return null;

  return (
    <div className="h-full flex flex-col">
      <div className="px-6 py-6">
        <button onClick={goBack} className="flex items-center gap-2 font-bold">
          <ArrowBackIosNewIcon fontSize="small" />
          Back <span className="opacity-50">|</span> {menu}
        </button>
      </div>

      <div className="flex-1 px-8 overflow-y-auto font-bold">
        {menu === "About" && (
          <ul className="space-y-5">
            {aboutMenu.map((item, i) => (
              <li key={i}>
                <HashLink to={item.link} onClick={onClose}>
                  {item.label}
                </HashLink>
              </li>
            ))}
          </ul>
        )}
        {menu === "Services" && (
          <ul className="space-y-6">
            <li>
              {" "}
              <Link to="/diagnostic-imaging-services" onClick={onClose}>
                All Services
              </Link>
            </li>
            <li>
              <MenuItem
                label="Imaging Subspecialties"
                onClick={() => openMenu("Imaging Subspecialties")}
              />
            </li>
            <li>
              <MenuItem
                label="Imaging Tests"
                onClick={() => openMenu("Imaging Tests")}
              />
            </li>
          </ul>
        )}

        {menu === "Imaging Subspecialties" && (
          <ul className="space-y-5">
            {servicesMegaMenu.subspecialties.map((item, i) => (
              <li key={i}>
                <Link
                  to={item.link}
                  onClick={onClose}
                  className="flex gap-3 items-center"
                >
                  <img src={item.icon} className="w-10 h-10" alt="" />
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        )}

        {menu === "Imaging Tests" && (
          <ul className="space-y-5">
            {servicesMegaMenu.Tests.map((item, i) => (
              <li key={i}>
                <Link
                  to={item.link}
                  onClick={onClose}
                  className="flex gap-3  items-center"
                >
                  <img src={item.icon} className="w-10 h-10" alt="" />
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        )}

        {menu === "Resources" && (
          <ul className="space-y-5">
            {resourcesMenu.map((item, i) => (
              <li key={i}>
                <Link to={item.link} onClick={onClose}>
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}

/* ================= MENU ITEM ================= */

function MenuItem({ label, onClick }) {
  return (
    <button
      onClick={onClick}
      className="w-full flex justify-between items-center"
    >
      <span>{label}</span>
      <ChevronRightIcon fontSize="small" />
    </button>
  );
}
